export enum FormModalCommandValues {
  NAME = 'name',
  COMPANY_ID = 'companyId',
}

export interface FormModalCommandData {
  [FormModalCommandValues.NAME]: string;
  [FormModalCommandValues.COMPANY_ID]?: string;
}
